var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowDown = function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M3.578 7.412a.833.833 0 0 1 1.179 0l4.827 4.828 4.827-4.828a.833.833 0 1 1 1.179 1.179l-4.828 4.827c-.65.65-1.706.65-2.357 0L3.578 8.591a.833.833 0 0 1 0-1.179",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowDown;